import { createSlice } from "@reduxjs/toolkit";

export const lockerSlice = createSlice({
  name: "@locker/slice",
  reducerPath: "@locker/slice",
  initialState: {
    isLocked: false,
  },
  reducers: {
    lock: () => ({ isLocked: true }),
    unlock: () => ({ isLocked: false }),
  },
  selectors: {
    selectIsLocked: (state) => state.isLocked,
  },
});
